/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Send_EmailInputs */

const cs_action_send_email = /** @type {(inputs: Action_Send_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat e-mail`)
};

const en_action_send_email = /** @type {(inputs: Action_Send_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send email`)
};

/**
* | output |
* | --- |
* | "Send email" |
*
* @param {Action_Send_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_send_email = /** @type {((inputs?: Action_Send_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Send_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_send_email(inputs)
	return cs_action_send_email(inputs)
});